export const DRAG_TYPE_TICKET_GROUP = "DRAG_TYPE_TICKET_GROUP";
export const DRAG_TYPE_TICKET_CLASS = "DRAG_TYPE_TICKET_CLASS";
export const DRAG_TYPE_ATTENDEE_QUESTION = "DRAG_TYPE_ATTENDEE_QUESTION";
export const DRAG_TYPE_ATTENDEE_QUESTION_CHOICE =
  "DRAG_TYPE_ATTENDEE_QUESTION_CHOICE";
